import { CSSProperties } from 'react';

export const styles = {
  buttonContainer: {
    display: 'flex',
    flex: 1,
    justifyContent: 'flex-end',
    marginBottom: 17,
    width: '95%'
  } as CSSProperties,
  button: {
    height: 34,
    width: 108,
    display: 'flex',
    justifyContent: 'center',
    backgroundColor: '#7876E0'
  } as CSSProperties,
  tableContainer: {
    width: '95%'
  } as CSSProperties,
}

export default styles;